export const EMPTY_REFERRAL_VALUES = {
  referral_date: null,
  provider_name: '',
  diagnosis_tool: '',
  city: '',
  state: '',
} as const;
